/**
 * External Links Constants
 * Centralized URLs for social media, resources, and app stores
 * Following Core Rules: Use constants for shared values
 */

/**
 * Social media profile links
 */
export const SOCIAL_LINKS = {
  INSTAGRAM: "https://www.instagram.com/trystasht",
  TIKTOK: "https://www.tiktok.com/@stasht",
  TWITTER: "https://x.com/trystasht",
  FACEBOOK: "https://www.facebook.com/trystasht",
} as const;

/**
 * App store links for ratings and downloads
 */
export const APP_STORE_LINKS = {
  IOS: "https://apps.apple.com/us/app/stasht-app-saves-that-work/id6756032175",
  ANDROID: "https://play.google.com/store/apps/details?id=app.stasht",
} as const;

/**
 * Support and resource links
 */
export const SUPPORT_LINKS = {
  HELP_CENTER: "https://help.stasht.app",
  FEEDBACK_EMAIL: "mailto:feedback@stasht.app",
  SUPPORT_EMAIL: "mailto:support@stasht.app",
  FEATUREBASE_PORTAL: "https://stasht.featurebase.app/",
} as const;

/**
 * Browser extension and shortcut links
 */
export const EXTENSION_LINKS = {
  CHROME_EXTENSION: "https://chromewebstore.google.com/detail/stasht/pnmkndkigheholgjnjklmaahpfanhcdg",
  SAFARI_EXTENSION: "https://apps.apple.com/us/app/stasht-app-for-safari/id6780505483?mt=12",
  SHORTCUT_TAP_TO_STASH: "https://www.icloud.com/shortcuts/fa63f1d1ced2417d891e275ab7c5207c",
  SHORTCUT_STASH_EDIT: "https://www.icloud.com/shortcuts/a8ad4b1f775c461a9b5af5562c1d8069",
} as const;

/**
 * Legal document links (internal routes)
 */
export const LEGAL_LINKS = {
  TERMS: "/terms",
  PRIVACY: "/privacy",
} as const;
